import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars , FaTimes } from 'react-icons/fa';
import '../Header/header.css'
import { useCart } from "react-use-cart";


export const Header = () => {
    const [icon, setIcon] = useState(false)
    const handleClick = () =>{
        setIcon(!icon)
    }
    const closeSideDrawer = () =>{
        setIcon(false)
    }

    const {
        isEmpty,
        totalItems,
      } = useCart();

    return (
        <div>
            <div className='topbar'><p>Free Delivery All Over India</p></div>

            <nav className='navbar'>
                <Link to='/' className='nav-logo' onClick={closeSideDrawer}>Tourister Bags</Link>

                <ul className={icon ? 'nav-menu active' : 'nav-menu'}>
                    <li><Link to='/' className='nav-links' onClick={closeSideDrawer}>Home</Link></li>
                    <li><Link to='/backpacks' className='nav-links' onClick={closeSideDrawer}>Backpacks</Link></li>
                    <li><Link to='/duffles' className='nav-links' onClick={closeSideDrawer}>Duffles</Link></li>
                    <li><Link to='/backpacks' className='nav-links' onClick={closeSideDrawer}>Luggages</Link></li>
                    <li><Link to='/cart' className='nav-links' onClick={closeSideDrawer}>Cart{!isEmpty && <span>{totalItems}</span>}</Link></li>
                </ul>

                <div className='menu-icon' onClick={handleClick}>{
                    icon ? <FaTimes className='fa-times'></FaTimes> : <FaBars className='fa-bars'></FaBars>}
                </div>
            </nav>
        </div>
    )
}
